import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from 'react-helmet-async';

import ContactSection from './ContactSection';
import CtaSection from './CtaSection';
import Partners from './Partners';
import Map from './Map';

const HeroSection = () => {
  return (
    <section className="home-container" id="inicio">
      <Container>
        <Row className="home-content-row">
          <Col md={8}>
            <div className="home-content">
              <h1 className="home-heading">BPO ESTRATÉGICO</h1>
              <h2 className="home-subheading">à frente do seu negócio</h2>
              <p className="home-description">
                Somos o primeiro BPO com foco estratégico. Mantemos sua operação transacional em excelência e assim damos
                confiança aos seus reportes, gerando visibilidade sobre a performance da sua empresa e permitindo uma boa
                tomada de decisão. Preparamos sua empresa para captação de dívida ou uma operação de M&amp;A.
              </p>
              <div className="home-cta-group">
                <a href="/quem-somos" className="home-button">Quem Somos</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Front BPO | BPO Estratégico</title>
        <meta
          name="description"
          content="Somos o primeiro BPO com foco estratégico. Mantemos sua operação transacional em excelência para permitir uma boa tomada de decisão."
        />
      </Helmet>
      <HeroSection />
      {/* <ServicesIntro /> */}
      <CtaSection />
      <Partners />
      <ContactSection />
      <Map />
    </>
  );
};

export default Home;
